import { createContext } from 'react';
export const OTPContext = createContext(null);
